import { Component, Output, EventEmitter, OnInit } from '@angular/core';
// import { State } from '@progress/kendo-data-query';
import { DatasourceService } from '@app/core/services';


@Component({
  selector: 'vehicle-menu',
  template: `
    <!--{{_selected | json}}-->
    <kendo-dropdownbutton [data]="data" textField="text" icon="k-icon k-i-more-vertical" look="flat" [popupSettings]="{animate: true, align: 'right'}">
      <ng-template kendoDropDownButtonItemTemplate let-dataItem>
        <span class="k-icon k-i-{{ dataItem.icon }}"></span>
        <span>{{ dataItem.text }}</span>
      </ng-template>
    </kendo-dropdownbutton>
  `,
})
export class VehicleMenuComponent implements OnInit {

  public data: Array<any> = [
    {
      id: 'cost_crane', text: "Definir costo de grúa", icon: "dollar",
      click: (dataItem: any) => {

        this.change(dataItem);                
  
      },
    },
    {
      id: 'photos', text: "Cargar fotografías", icon: "photo-camera",
      click: (dataItem: any) => {

        this.change(dataItem);                
  
      },
    }
  ];

  @Output() selected = new EventEmitter<any>();


  constructor(protected service : DatasourceService) { 

  }
    
  protected change(dataItem: any) {

    this.selected.emit({dataItem: dataItem});

  }

  ngOnInit() { 
  
  }

}